import * as React from 'react';
import { useAppSelector } from '../../hooks';
import { ReportAccessEnum } from '../../redux/ContactSlice';
import { selectedEntity } from '../../redux/EntitySlice';
import { EntityAuthorization, selectUserEntityAuthorizations, selectUserRole } from '../../redux/UserSlice';


const CanShowGiven29ReportAccess = (props: any) => {

    const entitySelector = useAppSelector(selectedEntity);
    const authorizedEntitiesSelector: Array<EntityAuthorization> | null = useAppSelector(selectUserEntityAuthorizations);
    const userRoleSelector = useAppSelector(selectUserRole);

    const [canEditEntity, setCanEditEntity] = React.useState<boolean>(false);

    React.useEffect(() => {

        if (userRoleSelector && userRoleSelector == "ADMIN") {
            setCanEditEntity(true);
        }
        else {
            if (entitySelector && authorizedEntitiesSelector) {

                var foundEntityAuthorization = authorizedEntitiesSelector.find((element: EntityAuthorization) => element.entity.code == entitySelector.code
                    && element.reportAccess == ReportAccessEnum.TWENTY_NINE.toString());

                if (foundEntityAuthorization) {

                    var foundEntityReportAccess = entitySelector.entityReportAccessChanges.find((element: any) => element.state == 'COURT_REPORTING_29_ENABLED'
                        && element.value == 'TRUE');

                    if (foundEntityReportAccess && (foundEntityAuthorization.entityContactRole != 'CONTACT' && foundEntityAuthorization.entityUserRole != 'NOTIFICATION')) {
                        setCanEditEntity(true);
                    }
                    else {
                        setCanEditEntity(false);
                    }
                }
                else {
                    setCanEditEntity(false);
                }
            } else {
                setCanEditEntity(false);
            }
        }

    }, [entitySelector])

    return (

        <React.Fragment>
            {
                canEditEntity == true ?
                    (
                        props.children
                    )

                    : (<></>)
            }
        </React.Fragment>
    );

}


export default CanShowGiven29ReportAccess;